// Auth Reducer
import { createReducer, on } from '@ngrx/store';
import { AuthState, initialAuthState } from './auth.state';
import * as AuthActions from './auth.actions';

export const authReducer = createReducer(
  initialAuthState,

  // Login
  on(AuthActions.login, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(AuthActions.loginSuccess, (state, { user, token, refreshToken }) => ({
    ...state,
    user,
    token,
    refreshToken,
    isAuthenticated: true,
    loading: false,
    error: null,
  })),
  on(AuthActions.loginFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
    isAuthenticated: false,
  })),

  // SSO Login
  on(AuthActions.ssoLogin, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(AuthActions.ssoLoginSuccess, (state, { user, token, refreshToken }) => ({
    ...state,
    user,
    token,
    refreshToken,
    isAuthenticated: true,
    loading: false,
    error: null,
  })),
  on(AuthActions.ssoLoginFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
    isAuthenticated: false,
  })),

  // Logout
  on(AuthActions.logout, AuthActions.logoutSuccess, () => ({
    ...initialAuthState,
  })),

  // Restore from storage
  on(AuthActions.restoreAuthSuccess, (state, { user, token, refreshToken }) => ({
    ...state,
    user,
    token,
    refreshToken,
    isAuthenticated: true,
    loading: false,
  })),
  on(AuthActions.restoreAuthFailure, () => ({
    ...initialAuthState,
  })),

  // Update profile
  on(AuthActions.updateProfile, (state, { user }) => ({
    ...state,
    user: state.user ? { ...state.user, ...user } : null,
  }))
);
